<template>
  <div class="hasbgpic hasHeader" style="margin-top: 40px">
    <div class="wjx-form" style="max-width: 800px; margin: 0 auto; padding: 20px;">
      <div class="vote-header">
        <div id="toptitle">
          <span class="htitle"><div>食育小记者站申请</div></span>
        </div>
      </div>
      <el-form :model="form" :rules="rules" ref="formRef" label-width="120px" size="large">
        <el-divider content-position="left">学校基本信息</el-divider>
        <el-form-item label="学校名称" prop="schoolName">
          <el-input v-model="form.schoolName" placeholder="请输入学校全称" @blur="checkSchoolName"></el-input>
          <span v-if="schoolNameExists" style="color: red">该学校已存在申请记录</span>
        </el-form-item>
        <el-form-item label="学校类型" prop="schoolType">
          <el-select v-model="form.schoolType" placeholder="请选择学校类型" style="width: 100%">
            <el-option label="小学" value="小学"></el-option>
            <el-option label="初中" value="初中"></el-option>
            <el-option label="高中" value="高中"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学校地址" prop="address">
          <el-cascader v-model="form.address" :options="regionData" :props="{ expandTrigger: 'hover', value: 'value', label: 'label', children: 'children' }" placeholder="请选择省市区" style="width: 100%" change-on-select></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="detailAddress">
          <el-input v-model="form.detailAddress" placeholder="请输入详细门牌号必填"></el-input>
        </el-form-item>
        <el-form-item label="邮编" prop="zipCode">
          <el-input v-model="form.zipCode" placeholder="请输入 6 位邮编" maxlength="6"></el-input>
        </el-form-item>
        <el-form-item label="学校特色" prop="schoolFeature">
          <el-input v-model="form.schoolFeature" type="textarea" :rows="3" placeholder="100 字以内必填" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-divider content-position="left">联系人信息</el-divider>
        <el-form-item label="联系人姓名" prop="contactName">
          <el-input v-model="form.contactName" placeholder="请输入联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系人职务" prop="contactPosition">
          <el-input v-model="form.contactPosition" placeholder="请输入职务必填"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="contactPhone">
          <el-input v-model="form.contactPhone" placeholder="请输入手机或固话"></el-input>
        </el-form-item>
        <el-form-item label="传真" prop="fax">
          <el-input v-model="form.fax" placeholder="请输入传真号码（选填）"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-divider content-position="left">站长信息</el-divider>
        <el-form-item label="站长姓名" prop="directorName">
          <el-input v-model="form.directorName" placeholder="请输入站长姓名"></el-input>
        </el-form-item>
        <el-form-item label="站长性别" prop="directorGender">
          <el-radio-group v-model="form.directorGender">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="站长年龄" prop="directorAge">
          <el-input-number v-model="form.directorAge" :min="18" :max="70" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="站长学历" prop="directorEducation">
          <el-select v-model="form.directorEducation" placeholder="请选择学历" style="width: 100%">
            <el-option label="大专" value="大专"></el-option>
            <el-option label="本科" value="本科"></el-option>
            <el-option label="硕士" value="硕士"></el-option>
            <el-option label="博士" value="博士"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="站长职务" prop="directorPosition">
          <el-input v-model="form.directorPosition" placeholder="请输入站长职务必填"></el-input>
        </el-form-item>
        <el-form-item label="站长职称" prop="directorTitle">
          <el-input v-model="form.directorTitle" placeholder="请输入站长职称必填"></el-input>
        </el-form-item>
        <el-form-item label="站长电话" prop="directorPhone">
          <el-input v-model="form.directorPhone" placeholder="请输入站长电话"></el-input>
        </el-form-item>
        <el-form-item label="站长邮箱" prop="directorEmail">
          <el-input v-model="form.directorEmail" placeholder="请输入站长邮箱"></el-input>
        </el-form-item>
        <el-form-item label="站长介绍" prop="directorIntroduction">
          <el-input v-model="form.directorIntroduction" type="textarea" :rows="4" placeholder="300 字以内必填" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-divider content-position="left">学校意见</el-divider>
        <el-form-item label="上传图片" prop="schoolOpinionImages">
          <el-upload action="/prod-api/admin/system/index/fileUpload" list-type="picture-card" :on-success="handleImageSuccess" :before-upload="beforeImageUpload" :file-list="imageList">
            <el-icon><Plus /></el-icon>
          </el-upload>
          <div style="color: #999; font-size: 12px;">仅支持 jpg/png 格式，图片≤5MB，需包含校长签字及单位盖章</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="submitting" style="width: 200px;">提交申请</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { Plus } from "@element-plus/icons-vue"
import { regionData, TextToCode } from "element-china-area-data"
import schoolStationApi from "@/api/schoolStationApply"
import { ElMessage } from "element-plus"

export default {
  name: "SchoolStationApply",
  components: { Plus },
  data() {
    return {
      regionData: regionData,
      TextToCode: TextToCode,
      form: {
        schoolName: "", schoolType: "", address: [], detailAddress: "",
        zipCode: "", schoolFeature: "", contactName: "", contactPosition: "",
        contactPhone: "", fax: "", email: "",
        directorName: "", directorGender: "男", directorAge: 30,
        directorEducation: "", directorPosition: "", directorTitle: "",
        directorPhone: "", directorEmail: "", directorIntroduction: "",
        schoolOpinionImages: ""
      },
      rules: {
        schoolName: [{ required: true, message: "请输入学校名称", trigger: "blur" }],
        schoolType: [{ required: true, message: "请选择学校类型", trigger: "change" }],
        address: [{ required: true, message: "请选择学校地址", trigger: "change" }],
        schoolFeature: [{ required: true, message: "请输入学校特色", trigger: "blur" }],
        zipCode: [{ required: true, message: "请输入邮编", trigger: "blur" }, { pattern: /^\d{6}$/, message: "邮编格式不正确", trigger: "blur" }],
        contactName: [{ required: true, message: "请输入联系人姓名", trigger: "blur" }],
        contactPhone: [{ required: true, message: "请输入联系人电话", trigger: "blur" }],
        contactPosition: [{ required: true, message: "请输入联系人职务", trigger: "blur" }],

        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }, { type: "email", message: "邮箱格式不正确", trigger: "blur" }],
        directorName: [{ required: true, message: "请输入站长姓名", trigger: "blur" }],
        directorAge: [{ required: true, message: "请输入站长年龄", trigger: "blur" }],
        directorPosition: [{ required: true, message: "请输入站长职务", trigger: "blur" }],
        directorTitle: [{ required: true, message: "请输入站长职称", trigger: "blur" }],
        directorIntroduction: [{ required: true, message: "请输入站长介绍", trigger: "blur" }],

        directorEducation: [{ required: true, message: "请选择站长学历", trigger: "change" }],
        directorPhone: [{ required: true, message: "请输入站长电话", trigger: "blur" }],
        directorEmail: [{ required: true, message: "请输入站长邮箱", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" }],
        schoolOpinionImages: [{ required: true, message: "请上传学校意见图片", trigger: "change" }]
      },
      imageList: [],
      schoolNameExists: false,
      submitting: false
    }
  },
  methods: {
    async checkSchoolName() {
      if (!this.form.schoolName) return
      try {
        const res = await schoolStationApi.checkSchoolName(this.form.schoolName)
        console.log("检查学校名称返回:", res)
        this.schoolNameExists = res.code !== 200 ? false : res.data
      } catch (e) {
        console.error("检查学校名称失败:", e)
        this.schoolNameExists = false
      }
    },
    handleImageSuccess(response, file, fileList) {
      console.log("图片上传返回:", response)
      this.imageList = fileList
      this.form.schoolOpinionImages = fileList.map(f => f.response?.data || f.response?.imageUrl || "").filter(Boolean).join(",")
    },
    beforeImageUpload(file) {
      const isImage = file.type === "image/jpeg" || file.type === "image/png"
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isImage) ElMessage.error("只能上传 JPG/PNG 格式!")
      if (!isLt5M) ElMessage.error("图片大小不能超过 5MB!")
      return isImage && isLt5M
    },
    async submitForm() {
      if (!this.$refs.formRef) return
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          console.log("表单验证失败")
          return
        }
        if (this.schoolNameExists) {
          ElMessage.warning("该学校已存在申请记录")
          return
        }
        this.submitting = true
        try {

          // 从 regionData 中查找对应的中文名称
          const getRegionName = (code, level = 0) => {
            let currentOptions = this.regionData

            for (let i = 0; i <= level; i++) {
              const found = currentOptions.find(item => item.value === this.form.address[i])
              if (!found) return ""

              if (i === level) {
                return found.label
              }

              if (found.children && found.children.length > 0) {
                currentOptions = found.children
              } else {
                return ""
              }
            }
            return ""
          }
          // 使用 TextToCode 将选择值转换为中文名称
          console.log("TextToCode:", TextToCode)
          console.log(this.regionData)
          console.log(this.form.address[0])
          console.log(this.form.address[1])
          console.log(this.form.address[2])
          const province = this.form.address.length > 0 ? getRegionName(this.form.address[0], 0) : ""
          const city = this.form.address.length > 1 ? getRegionName(this.form.address[1], 1) : ""
          const district = this.form.address.length > 2 ? getRegionName(this.form.address[2], 2) : ""

          const submitData = {
            ...this.form,
            province: province,
            city: city,
            district: district
          }
          delete submitData.address
          console.log("提交数据:", submitData)
          const res = await schoolStationApi.submitApply(submitData)
          console.log("提交返回:", res)
          if (res.code === 200) {
            ElMessage.success({
              message: "申请提交成功，请等待审核",
              duration: 5000
            })
            this.$refs.formRef.resetFields()
            this.imageList = []
          } else {
            ElMessage.error(res.message || "提交失败")
          }
        } catch (e) {
          console.error("提交申请错误:", e)
          ElMessage.error(e.message || "提交失败，请稍后重试")
        }
        finally { this.submitting = false }
      })
    }
  }
}
</script>

<style scoped>@import "../assets/fs/newForm.css";</style>
